import { render, staticRenderFns } from "./ReceiptsPagination.vue?vue&type=template&id=6dc2f838&"
import script from "./ReceiptsPagination.vue?vue&type=script&lang=js&"
export * from "./ReceiptsPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dc2f838')) {
      api.createRecord('6dc2f838', component.options)
    } else {
      api.reload('6dc2f838', component.options)
    }
    module.hot.accept("./ReceiptsPagination.vue?vue&type=template&id=6dc2f838&", function () {
      api.rerender('6dc2f838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/receipts/views/components/ReceiptsPagination.vue"
export default component.exports